import Figure from './Figure'
import Image from './Image'
import Video from './Video'

export default { Figure, Image, Video }
